import { Box, Button, Section } from '@factorialco/deprecated-design-system'
import { EmployeeBlocksEmployeeFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import FormComponent from 'modules/core/components/Form'
import FormRow from 'modules/core/components/FormRow'
import Text from 'modules/core/components/Inputs/Text'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { formGetDirtyFields } from 'modules/core/lib/formGetDirtyFields'
import i18n from 'modules/core/lib/i18n'
import validateNumberInput from 'modules/core/lib/validateNumberInput'

import {
  FormTypes,
  useEmployeePersonalProvider,
} from 'modules/employees/components/blocks/EmployeePersonalProvider'

const COUNTRIES_WITHOUT_PERSONAL_SITUATION = ['gb', 'us']

interface Props {
  employee: EmployeeBlocksEmployeeFragment
  readonly: boolean
}

export const PersonalSituation = observer(({ employee, readonly }: Props) => {
  const {
    personalSituationForm: form,
    onSubmit: onSubmitPersonalSituation,
    disableSectionSaveButtons,
  } = useEmployeePersonalProvider()

  const onSubmit = async () => {
    track(trackingEvents.employee.editEmployeeInformationSubmit, {
      fields_edited: formGetDirtyFields(form),
      legal_entity_country: employee.legalEntity?.country,
      layout_version: 'v1',
    })
    onSubmitPersonalSituation([FormTypes.PERSONAL_SITUATION])
  }

  return (
    <FormComponent>
      <FormRow>
        <Text
          label={i18n.t('employee_form.personal_situation.form.disability_percentage')}
          field={form.get('disability_percentage_cents')}
          readonly={readonly}
          validation={validateNumberInput}
        />
      </FormRow>
      {!disableSectionSaveButtons && form.isDirty && (
        <FormRow footer>
          <Button onClick={onSubmit}>{i18n.t('common.submit')}</Button>
        </FormRow>
      )}
    </FormComponent>
  )
})

const PersonalSituationWrapper = (props: Props) => {
  const employeeCountry = props.employee.legalEntity?.country

  if (COUNTRIES_WITHOUT_PERSONAL_SITUATION.includes(employeeCountry || '')) {
    return null
  }

  return (
    <Section
      description={i18n.t('employee_form.personal_situation.description')}
      illustration="love-hands"
      title={i18n.t('employee_form.personal_situation.title')}
    >
      <Box maxWidth="s360" alignSelf="end" width="s360">
        <Box
          padding="s24"
          background="grey200"
          borderRadius={{
            all: 'abs004',
          }}
        >
          <PersonalSituation {...props} />
        </Box>
      </Box>
    </Section>
  )
}

export default observer(PersonalSituationWrapper)
